export function getLocalStore(name, decode = false, boolean = false)
{
    const store = localStorage.getItem(name)
    if(decode){
        return JSON.stringify(store)
    }
    if(boolean){
        return store === "true" ? true : false
    }
    return store;
}

export function setLocalStore(name, data, encode = false)
{
    localStorage.setItem(
        name, (encode ? JSON.stringify(data) : data)
    )
}

export function deleteLocalStore(name)
{
    localStorage.removeItem(name)
}

export function purgeLocalStore()
{
    localStorage.clear()
}
